"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getContext = (canvas, opts, version) => {
  let gl;
  if (version === "webgl2" || version === "auto") {
    gl = canvas.getContext("webgl2", opts);
  }
  if (!gl && (version === "webgl" || version === "auto")) {
    gl = canvas.getContext("webgl", opts) || canvas.getContext("webgl-experimental", opts) || canvas.getContext("experimental-webgl", opts);
  }
  return gl;
};
var _default = getContext;
exports.default = _default;